module.exports = __webpack_public_path__ + "img/141.0dec7418.png";